function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;
    var placeholderMatch = formatString.match(placeholderRegex);

    if (!placeholderMatch) {
        return formatWithDelimiters(cents, 2);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (placeholderMatch[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
        case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', ',');
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
        default:
            value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0)
            return c.substring(name.length, c.length);
    }
    return "";
}
var slideIndex = 0;

function addSlide(div) {
    $('.compare-block-slider').slick('slickAdd', div);
}

function addCompareItem(elem) {
  
    if ($('.compare-block .item').length == 0) {
        $('.compare-block').show();
        $('.compare-block').addClass('active');
    }
    var image_url = elem.data('image');
    var product_name = elem.data('title');
    var price = formatMoney(elem.data('price'), window.moneyFormat);
    var div = $("<div>", {
        id: "item_" + elem.data('product-id'),
        "class": "item",
        "data-product-id": elem.data('product-id')
    });
    var itemHtml = '<div class="image"><img src="' + image_url + '"/></div>' +
        '<div class="details"><h4>' + product_name + '</h4><div class="price">' + price + '</div></div>' +
        '<a href="javascript:void(0);" class="remove"><span>x</span></a>';
    $(div).html(itemHtml);
    slideIndex++;
    addSlide(div);


}

function setCompareCookieGrid() {

    var count = 0;
    var ids = "";
    $('.compare-block').find('.item').each(function() {
        count++;
        if (count == 1) {
            ids += $(this).data('product-id');
        } else {
            ids += '|' + $(this).data('product-id');
        }
    });
    setCookie("compare_product_ids", ids, 0.020);

    if ($('.compare-block .item').length == 0) {
        $('.compare-block').hide();
        $('.compare-block').removeClass('active');
    }
}

function setCompareCookie(id) {
    var ids = id;

    if (getCookie("compare_product_ids")) {
        var compare_product_ids = getCookie("compare_product_ids");
        var array_id = compare_product_ids.split("|");
        for (var k in array_id) {
            if (array_id[k] != id) {
                ids += '|' + array_id[k];
            }
        }
        setCookie("compare_product_ids", ids, 0.020);
    } else {
        setCookie("compare_product_ids", id, 0.020);
    }
}

// function removeProductToCompare(id) {
//     var ids = "";
//     var count = 0;
//     if (getCookie("compare_product_ids")) {
//         var compare_product_ids = getCookie("compare_product_ids");
//         var array_id = compare_product_ids.split("|");
//         for (var k in array_id) {
//             if (array_id[k] != id) {
//                 count++;
//                 if (count == 1) {
//                     ids += array_id[k];
//                 } else {
//                     ids += '|' + array_id[k];
//                 }
//             }
//         }
//         setCookie("compare_product_ids", ids, 30);
//     }
// }

// function showProgress() {
//     $("#ajax-overlay").show();
//     $("#ajax-progress").show();
// };

// function hideProgress() {
//     $("#ajax-overlay").hide();
//     $("#ajax-progress").hide();
// };

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function convertAndFormatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }

    var rate = window.Shopify?.currency?.rate || 1;
    var activeCurrency = window.Shopify?.currency?.active || 'CAD';

    var convertedCents = Math.round(cents * rate);

    return formatMoney(convertedCents, format);
}
    function presentmentToBase(priceInPresentmentCents) {
      const rate = window.Shopify?.currency?.rate || 1;
      return Math.round(priceInPresentmentCents / rate);
  }

  
function logSearchToGoogleSheet(event, value) {
  const img = new Image();

  img.src =
    'https://script.google.com/macros/s/AKfycbznvnI4OZmbIrh3WSMpSLfJGQwe9osedtLSDhaMUgegLSnsIQeuR1m_hPKycaPBz_On/exec'
    + '?event=' + encodeURIComponent(event)
    + '&value=' + encodeURIComponent(value)
    + '&page=' + encodeURIComponent(location.href)
    + '&ua=' + encodeURIComponent(navigator.userAgent)
    + '&_t=' + Date.now(); // cache-buster
}

// ===== hoverIntent.js =====
  function hoverIntent(el, options) {
  const settings = Object.assign({
    sensitivity: 7,     
    interval: 100,     
    timeout: 200,      
    over: () => {},    
    out: () => {}     
  }, options);

  let x, y, pX, pY;
  let h = null, state = 0, timeoutId = null;

  function track(e) {
    x = e.clientX;
    y = e.clientY;
  }

  function compare(e) {
    if (timeoutId) clearTimeout(timeoutId);
    if ((Math.abs(pX - x) + Math.abs(pY - y)) < settings.sensitivity) {
      el.removeEventListener("mousemove", track);
      state = 1;
      settings.over.call(el, e);
    } else {
      pX = x; pY = y;
      h = setTimeout(() => compare(e), settings.interval);
    }
  }

  function dispatchOver(e) {
    if (h) clearTimeout(h);
    el.addEventListener("mousemove", track);
    pX = e.clientX; pY = e.clientY;
    h = setTimeout(() => compare(e), settings.interval);
  }

  function dispatchOut(e) {
    if (h) clearTimeout(h);
    el.removeEventListener("mousemove", track);
    if (state === 1) {
      timeoutId = setTimeout(() => {
        settings.out.call(el, e);
        state = 0;
      }, settings.timeout);
    }
  }

  el.addEventListener("mouseenter", dispatchOver);
  el.addEventListener("mouseleave", dispatchOut);
}

function scrollParentToChild(child, parent,scrollFlag) {

    const OFFSET = 20;

    const childRect = child.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    const currentScroll = parent.scrollTop;

    const offsetTop = childRect.top - parentRect.top + currentScroll;
    const offsetBottom = childRect.bottom - parentRect.top + currentScroll;

    if(scrollFlag) {
        parent.scrollTo({
            top: offsetTop - OFFSET,
            behavior: 'smooth'
        });
    } else {
        if (childRect.top < parentRect.top) {
            parent.scrollTo({
            top: offsetTop - OFFSET,
            behavior: 'smooth'
            });
        }

        else if (childRect.bottom > parentRect.bottom) {
            parent.scrollTo({
            top: offsetBottom - parent.clientHeight + OFFSET,
            behavior: 'smooth'
            });
        }
    }
}
function isFullyVisibleVertically(child, parent) {
    const childRect = child.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    return (
        childRect.top >= parentRect.top &&
        childRect.bottom <= parentRect.bottom
    );
}